export default __webpack_public_path__ + "static/DianaArcherMills-668c8493ee61dd3963049992f5b1cef2.png";